<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>{{ (id === 'new' ? 'Nueva' : 'Editar') + ' tarea' }}</h3>
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <h4>Características</h4>

            <b-form-row>
              <b-col cols="12">
                <b-form-row>
                  <!-- Reference -->
                  <b-form-group
                    id="input-code"
                    class="col-2"
                    label="Código"
                    label-for="code"
                  >
                    <b-form-input
                      id="code"
                      v-model="$v.form.code.$model"
                      :state="validateState('code')"
                      aria-describedby="input-code-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-code-feedback"
                      >Este campo es obligatorio.</b-form-invalid-feedback
                    >
                  </b-form-group>
                  <b-form-group
                    id="input-description"
                    class="col-10"
                    label="Descripción"
                    label-for="description"
                  >
                    <b-form-input
                      id="description"
                      v-model="$v.form.description.$model"
                      :state="validateState('description')"
                      aria-describedby="input-description-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-description-feedback"
                      >Este campo es obligatorio.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-form-row>
              </b-col>
            </b-form-row>

            <b-button type="submit" variant="primary">Guardar tarea</b-button>
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { required, decimal, minValue } from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';

import * as Sentry from '@sentry/browser';

import Multiselect from 'vue-multiselect';

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminWorkshopTasksEditScreen',
  props: ['id'],
  components: { Multiselect, VueCropper },
  mixins: [validationMixin],
  validations() {
    let rules = {
      code: {
        required,
      },

      description: { required },
    };

    // this.languageCodes.map((x) => {
    //   rules['name_' + x] = { required };
    // });

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      code: '',
      description: '',
      error: {
        show: false,
        text: '',
      },
    };

    // store.getLanguageCodes().map((x) => {
    //   form['name_' + x] = '';
    // });

    return {
      sharedState: store.state,
      form: form,
    };
  },
  created() {
    let that = this;
    actions.getWorkshopTask(this.id).then((x) => {
      const data = x.data;

      this.form.code = data.code;

      this.form.description = data.description;

      // this.languageCodes.map((y) => {
      //   this.form['name_' + y] = data['name_' + y];
      // });
    });
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = new FormData();

      //pepe

      data.append('code', this.form.code);
      data.append('description', this.form.description);

      Sentry.setExtra('data', JSON.stringify(Object.fromEntries(data)));

      if (this.id !== 'new') {
        actions.patchWorkshopTask(this.id, data).then(() => {
          this.$router.push({ name: 'AdminWorkshopTasksScreen' });
        });
      } else {
        actions.postWorkshopTask(data).then(() => {
          this.$router.push({ name: 'AdminWorkshopTasksScreen' });
        });
      }
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
